import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import FeedbackScreen from '../../pages/mobile/feedback/FeedbackScreen';
import FeedbackFinishScreen from '../../pages/mobile/feedback/FeedbackFinishScreen';

function MobileFeedbackLayout() {

  return (
    <>
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/feedback/finish">
                <FeedbackFinishScreen />
              </Route>
              <Route path="/feedback">
                <FeedbackScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileFeedbackLayout;
